export default "__VITE_ASSET__281e36c4__"